// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GarminInputWrapper_garminInputWrapper__9xpbj {
    display: block;
}

.GarminInputWrapper_garminInputWrapper__9xpbj input,
.GarminInputWrapper_garminInputWrapper__9xpbj select {
    box-shadow: none;
    height: 2rem;
    border-radius: 4px;
    font-size: 14px;
}

.GarminInputWrapper_label__PPh98 {
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-size: 14px;
    line-height: 21px;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
}

.GarminInputWrapper_label__PPh98:hover {
    cursor: default;
}

.GarminInputWrapper_helperText__PPpbT {
    display: flex;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    margin-top: 4px;
    color: var(--color-darkui-accent-2);
}

.GarminInputWrapper_helperTextFlex__eg0QG {
    display: flex;
    position: absolute;
    height: fit-content;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    margin-top: 4px;
    color: var(--color-darkui-accent-2);
}

.GarminInputWrapper_validationError__iIDIC {
    display: flex;
    align-items: flex-start;
    margin-top: 4px;
}

.GarminInputWrapper_multiValidationError__DsRhI {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: fit-content;
    margin-top: 4px;
}

.GarminInputWrapper_inputWrapperError__4g36A > select {
    outline: 2.5px solid var(--color-red-dark-1);
    outline-offset: -1.5px;
}

.GarminInputWrapper_validationErrorIcon__1dljd {
    color: var(--color-red-dark-1);
    margin-top: 1px;
    width: 16px;
}

.GarminInputWrapper_validationErrorText__mH\\+2w {
    margin-left: 4px;
    color: var(--color-red-dark-1);
    height: fit-content;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
}

.GarminInputWrapper_validationErrorFlex__WcjZ6 {
    display: flex;
    height: fit-content;
    position: absolute;
    margin-top: 4px;
}

.GarminInputWrapper_multiValidationErrorFlex__P2mgh {
    display: flex;
    flex-direction: column;
    height: fit-content;
    position: absolute;
    margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/GarminInputWrapper/GarminInputWrapper.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uHAAuH;IACvH,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uHAAuH;IACvH,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uHAAuH;IACvH,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,uHAAuH;IACvH,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".garminInputWrapper {\n    display: block;\n}\n\n.garminInputWrapper input,\n.garminInputWrapper select {\n    box-shadow: none;\n    height: 2rem;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.label {\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-size: 14px;\n    line-height: 21px;\n    display: flex;\n    align-items: center;\n    margin-bottom: 4px;\n}\n\n.label:hover {\n    cursor: default;\n}\n\n.helperText {\n    display: flex;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    margin-top: 4px;\n    color: var(--color-darkui-accent-2);\n}\n\n.helperTextFlex {\n    display: flex;\n    position: absolute;\n    height: fit-content;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    margin-top: 4px;\n    color: var(--color-darkui-accent-2);\n}\n\n.validationError {\n    display: flex;\n    align-items: flex-start;\n    margin-top: 4px;\n}\n\n.multiValidationError {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    height: fit-content;\n    margin-top: 4px;\n}\n\n.inputWrapperError > select {\n    outline: 2.5px solid var(--color-red-dark-1);\n    outline-offset: -1.5px;\n}\n\n.validationErrorIcon {\n    color: var(--color-red-dark-1);\n    margin-top: 1px;\n    width: 16px;\n}\n\n.validationErrorText {\n    margin-left: 4px;\n    color: var(--color-red-dark-1);\n    height: fit-content;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n}\n\n.validationErrorFlex {\n    display: flex;\n    height: fit-content;\n    position: absolute;\n    margin-top: 4px;\n}\n\n.multiValidationErrorFlex {\n    display: flex;\n    flex-direction: column;\n    height: fit-content;\n    position: absolute;\n    margin-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"garminInputWrapper": `GarminInputWrapper_garminInputWrapper__9xpbj`,
	"label": `GarminInputWrapper_label__PPh98`,
	"helperText": `GarminInputWrapper_helperText__PPpbT`,
	"helperTextFlex": `GarminInputWrapper_helperTextFlex__eg0QG`,
	"validationError": `GarminInputWrapper_validationError__iIDIC`,
	"multiValidationError": `GarminInputWrapper_multiValidationError__DsRhI`,
	"inputWrapperError": `GarminInputWrapper_inputWrapperError__4g36A`,
	"validationErrorIcon": `GarminInputWrapper_validationErrorIcon__1dljd`,
	"validationErrorText": `GarminInputWrapper_validationErrorText__mH+2w`,
	"validationErrorFlex": `GarminInputWrapper_validationErrorFlex__WcjZ6`,
	"multiValidationErrorFlex": `GarminInputWrapper_multiValidationErrorFlex__P2mgh`
};
export default ___CSS_LOADER_EXPORT___;
